import { render, staticRenderFns } from "./deleteVehicleModal.vue?vue&type=template&id=70b53ef9&"
import script from "./deleteVehicleModal.vue?vue&type=script&lang=js&"
export * from "./deleteVehicleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports